import React from 'react';
import { translate } from 'react-i18next';
import {Form, Button, Label, Icon, Header, Input} from 'semantic-ui-react'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import MomentLocaleUtils from 'react-day-picker/moment';
import YearMonthForm from 'modules/misc/YearMonthForm.js';

import SurveyButtons from './SurveyButtons.js';
import {colors} from 'style';
import styleDef from './style.js';

var style = {
    ...styleDef,
    
}

const SurveyPageDate = ({t, 
                         surveyPage, 
                         inlineButtons, 
                         value, 
                         valid, 
                         onChange, 
                         onChangeDateText, 
                         onSubmit, 
                         onSkip, 
                         pageNum, 
                         numPages, 
                         format}) => (
    <div style={style.container}>
    <div style={style.blank}>
        <div style={style.content}>
            <form onSubmit={onSubmit} autoComplete='off'>

                <div style={style.header}>{surveyPage.title}</div>

                {numPages &&
                    <div style={style.pageCount}>
                        {t('page_{{pageNum}}_{{numPages}}',{pageNum, numPages})}
                    </div>
                }


                <div style={style.description}>
                    {surveyPage.description}
                </div>
               
                <div style={style.body}>
                    <DayPickerInput
                          name="date"
                          classNames={{container:"DayPickerInput", 
                                       overlay:"DayPickerInput-Overlay",
                                       overlayWrapper:"DayPickerInput-OverlayWrapper"}}
                          placeholder={format}
                          format={format}
                          value={value}
                          component={Input}
                          onDayChange={onChange}
                          onChange={onChangeDateText}
                          dayPickerProps={{locale:localStorage.i18nextLng,
                                           localeUtils:MomentLocaleUtils,
                                           captionElement:<YearMonthForm onChange={onChange}/>,
                                           month:YearMonthForm.fromMonth}}
                           /> 
                </div>

                <SurveyButtons canSkip={surveyPage.canSkip} onSkip={onSkip} onSubmit={onSubmit} valid={valid} inlineButtons={inlineButtons} />
                {!inlineButtons &&
                    <div style={style.spacer} />
                }
            </form>

            {/*<pre style={{textAlign: 'left'}}>{JSON.stringify(survey,null,2)}</pre>*/}
        </div>
    </div>
    </div>
);

export default translate('surveys')(SurveyPageDate);



// WEBPACK FOOTER //
// ./src/modules/surveys/types/SurveyPageDate.js